/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export { AjaxMonitor as AjaxPlugin } from "./ajax";
export { ajaxRecord } from "./ajaxRecord";
//# sourceMappingURL=applicationinsights-dependencies-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-dependencies-js/dist-esm/applicationinsights-dependencies-js.js
// module id = 122
// module chunks = 0